import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_SI.json';
import exercises from './YOGA_EXERCISES_SI.json';
import recipes from './YOGA_RECIPES_SI.json';

export const YOGA_DATA_SI: ServiceData = {
  articles,
  exercises,
  recipes,
};
